import React from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';
import SearchSubInfoBlock from 'shared/components/SearchSubInfoBlock/SearchSubInfoBlock';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import ListAds from 'shared/components/ListAds/ListAds';
import { DesktopButton } from 'shared/components/BannerAll';
// import CarItem from 'desktop/components/CarItem/CarItem';
import CarLeasingItem from 'desktop/components/CarLeasingItem/CarLeasingItem';
import CarDefaultItem from 'desktop/components/CarDefaultItem/CarDefaultItem';

// import CarDriveItem from 'desktop/components/CarDriveItem/CarDriveItem';
// import MgidAds from 'shared/components/AdsBlocks/MgidAds';
import { ContentRollAdsense } from 'shared/modules/googletag/contentRollAdsense';

import { FormattedMessage } from 'react-intl';
import s from './CarsList.css';

const IMAGE_WIDTH = 228;

class CarsList extends React.Component {
  static propTypes = {
    cars: PropTypes.arrayOf(PropTypes.shape()).isRequired,
    currency: PropTypes.shape().isRequired,
    currentPage: PropTypes.number.isRequired,
    afterFourthSlot: PropTypes.node,
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  };
  static defaultProps = {
    afterFourthSlot: null,
  };
  render() {
    const { cars, currency, currentPage, afterFourthSlot, title } = this.props;
    const carDrivePlace = cars && cars.length < 15 ? cars.length - 1 : 15;

    return (
      <div className={s.root}>
        {cars && cars.length > 0 ? (
          cars.map((item, idx) => (
            <React.Fragment key={item.id}>
              <ListAds index={idx} />
              {idx === 4 && afterFourthSlot}
              {idx === 6 && <DesktopButton />}
              {item.is_default ? (
                <CarDefaultItem
                  width={IMAGE_WIDTH}
                  car={item}
                  currency={currency}
                  currentPage={currentPage}
                  index={idx}
                  title={title}
                />
              ) : (
                <CarLeasingItem
                  width={IMAGE_WIDTH}
                  car={item}
                  currency={currency}
                  currentPage={currentPage}
                  index={idx}
                  title={title}
                />
              )}
              {idx === carDrivePlace && <ContentRollAdsense />}
            </React.Fragment>
          ))
        ) : (
          <div className={s.defaultText}>
            <FormattedMessage id={'По Вашему запросу ничего не найдено'} />
          </div>
        )}
        <SearchSubInfoBlock styles={cx(s.subInfoBlock, { [s.subMargin]: cars.length <= 15 })} />
      </div>
    );
  }
}

export default withStyles(s)(CarsList);



// WEBPACK FOOTER //
// ./src/desktop/routes/search/components/CarsList/CarsList.js